import styled from '@emotion/styled';

export const Category = styled.span`
    display: none;
`;
